import { useTranslation } from 'react-i18next';

import Chip from '@material-ui/core/Chip';
import styled from 'styled-components';

const StyledChip = styled(Chip) <{ styledColor: string }>`
    border: 1px ${p => p.styledColor} solid;
    color: ${p => p.styledColor};
    background-color: #ffffff;
    font-weight: bold;
`;

interface Props {
    approved: boolean;
}

const ApprovalStatusChip = ({ approved }: Props) => {
    const { t } = useTranslation();

    return (
        <StyledChip
            label={t('pages.plastic_assessment.tabs.kpi.table.' + (approved ? 'approved' : 'not_approved'))}
            styledColor={approved ? '#1e7e34' : '#f50057'}
        />
    );
};

export default ApprovalStatusChip;